import { render, staticRenderFns } from "./MaturityBenefit.vue?vue&type=template&id=5cd14e31"
import script from "./MaturityBenefit.vue?vue&type=script&lang=js"
export * from "./MaturityBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports